import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {forkJoin, Observable} from 'rxjs';
import {NavigationService} from 'app/core/navigation/navigation.service';
import {UserService} from 'app/core/user/user.service';
import {AuthService} from "./core/auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver  {
    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        private _userService: UserService

    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        // Fork join multiple API endpoint calls to wait all of them to finish

        return forkJoin(this._navigationService.get(),this._userService.getGoogleUser())

    }
}
